export enum ConfirmationIconType {
  WARN = 'WARN',
  SAVE = 'SAVE',
}
